import moment from 'moment'

export const formatDate = (date, formatter = 'YYYY-MM-DD') => moment(date).format(formatter)

export const diffDate = (start, end, type = 'days') => moment(end).diff(moment(start), type)
